import React from 'react'
import image from '@loyal_images/products/product_placeholder.png'

const CheckoutPlaceholder = props => (
  <div className='row px-0 pb-2 border-bottom border-color-ui-3 bg-ui-5'>
    <div className='col-12 px-2'>
      <div className='row mx-1'>
        <div className='col-12 border-color-ui-3 pt-2'>
          <div className='row'>
            <div className='col-12 row mx-0 px-0'>
              <div className='col-10 px-2 radius bg-ui-3 pt-1' />
            </div>
          </div>
        </div>
        <div className='payment-item item h-auto col-12 border-color-ui-3  pt-2 '>
          <div className='row align-items-center mb-1'>
            <div className='col-auto px-1 radius-circle bg-ui-3 py-1' />
            <div className='col'>
              <div className='col-8 px-1 radius bg-ui-3 pt-1' />
            </div>
            <div className='col'>
              <div className='offset-6 col-6 px-1 radius bg-ui-3 pt-1' />
            </div>
          </div>
          <div className='row align-items-center'>
            <div className='col-auto px-1 radius-circle bg-ui-3 py-1' />
            <div className='col-4'>
              <div className='col-12 px-1 radius bg-ui-3 pt-1' />
            </div>
            <div className='col-2 pl-0'>
              <div className='col-1 px-1 radius-circle bg-ui-3 py-1' />
            </div>
            <div className='col row mx-0 justify-content-between'>
              <div
                className='col-auto px-2 bg-ui-3 pt-2 pb-1 mr-1'
                style={{
                  backgroundImage: 'url(' + image + ')',
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'cover',
                  backgroundPosition: '0 -6px'
                }}
              />
              <div
                className='col-auto px-2 bg-ui-3 pt-2 pb-1 mr-1'
                style={{
                  backgroundImage: 'url(' + image + ')',
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'cover',
                  backgroundPosition: '0 -6px'
                }}
              />
              <div
                className='col-auto px-2 bg-ui-3 pt-2 pb-1 mr-1'
                style={{
                  backgroundImage: 'url(' + image + ')',
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'cover',
                  backgroundPosition: '0 -6px'
                }}
              />
              <div
                className='col-auto px-2 bg-ui-3 pt-2 pb-1 mr-1'
                style={{
                  backgroundImage: 'url(' + image + ')',
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'cover',
                  backgroundPosition: '0 -6px'
                }}
              />
              <div
                className='col-auto px-2 bg-ui-3 pt-2 pb-1 mr-1'
                style={{
                  backgroundImage: 'url(' + image + ')',
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'cover',
                  backgroundPosition: '0 -6px'
                }}
              />
              <div
                className='col-auto px-2 bg-ui-3 pt-2 pb-1'
                style={{
                  backgroundImage: 'url(' + image + ')',
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'cover',
                  backgroundPosition: '0 -6px'
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default CheckoutPlaceholder



// WEBPACK FOOTER //
// ./src/features/Checkout/Payment/Body/BodyPlaceholder.js